'use client'

import { useCallback } from 'react'
import { useClerk } from '@clerk/nextjs'

/**
 * Sign out with a HARD navigation to /sign-in instead of Clerk's default
 * afterSignOutUrl redirect through the Next.js App Router.
 *
 * Why: during sign-out the auth-state flip re-renders the whole tree while
 * Clerk's redirect and our own signed-out redirect race through the App
 * Router. In production this trips a known Next.js bug
 * (https://github.com/vercel/next.js/issues/63121): the Router component
 * itself throws React #310 ("Rendered more hooks than during the previous
 * render"). Router sits above the entire tree, so NO error boundary can
 * catch it and the app crashes into global-error. window.location.replace
 * bypasses the App Router reducer entirely, and a full page load at
 * /sign-in is correct anyway: the session is gone.
 *
 * Always use this (never Clerk's SignOutButton or a bare clerk.signOut())
 * to trigger sign-out. An ESLint no-restricted-imports rule enforces the
 * SignOutButton half of that.
 */
export default function useHardSignOut() {
  const { signOut } = useClerk()
  return useCallback(
    // Passing a callback suppresses Clerk's own redirect.
    () =>
      signOut(() => {
        window.location.replace('/sign-in')
      }),
    [signOut],
  )
}
